import React from 'react';
import { FilterQuery } from './Filter.query';

export const Filter = () => {
  return <FilterQuery />;
};
